import { useLocation } from "@tanstack/react-router";
import { useLayoutEffect } from "react";
import { SELECTOR } from "%/constant";
import { useInformListStore } from "&/informList";
import { useBusinessNotifyStore } from "&/businessNotifyList";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // 알림장 목록으로 '뒤로가기 복원' 진입하는 경우 스크롤 리셋을 전부 건너뛴다.
    // 목록 화면이 저장된 위치로 스크롤을 복원하는데, 여기의 지연 리셋(rAF/50ms/150ms)이
    // 복원 스크롤을 도로 0으로 덮어쓰는 것을 방지 (returning 플래그는 목록 마운트 후 소비됨)
    if (
      pathname === "/customer/layout/inform" &&
      useInformListStore.getState().returning
    ) {
      return;
    }
    if (
      pathname === "/business/layout/notify" &&
      useBusinessNotifyStore.getState().returning
    ) {
      return;
    }

    const reset = () => {
      try {
        const mainElement = document.getElementById(SELECTOR.MAIN);
        if (mainElement) mainElement.scrollTop = 0;
        const appElement = document.getElementById(SELECTOR.APP);
        if (appElement) appElement.scrollTop = 0;
        window.scrollTo(0, 0);
        if (document.scrollingElement) {
          document.scrollingElement.scrollTop = 0;
        }
        // scroll any scrollable descendants back to top (covers pages
        // that render their own overflow container inside main)
        document
          .querySelectorAll<HTMLElement>(
            "[data-scroll-reset], .overflow-auto, .overflow-y-auto"
          )
          .forEach((el) => {
            el.scrollTop = 0;
          });
      } catch (error) {
        console.error("Scroll error:", error);
      }
    };

    // immediate (pre-paint)
    reset();
    // next frame (after first paint, covers Portal late-mount)
    const raf1 = requestAnimationFrame(reset);
    // two frames later (covers secondary layout shifts from async data load)
    let raf2 = 0;
    const raf2Outer = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(reset);
    });
    // fallback timeouts for remaining edge cases (API-driven height changes)
    const t1 = window.setTimeout(reset, 50);
    const t2 = window.setTimeout(reset, 150);

    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2Outer);
      cancelAnimationFrame(raf2);
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [pathname]);

  return null;
}
